module.exports = __webpack_public_path__ + "static/fonts/ArialBlack.cd5be9b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/ArialBlack.ttf
// module id = oE0z
// module chunks = 1